import React from 'react';
import './model.cmp.scss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import OutsideClickHandler from 'react-outside-click-handler';
import { Icon } from '@fortawesome/fontawesome-svg-core';
import PLButton from '../common/button/PLButton';

const ModelCmp = ({
    name,
    bodyComponent,
    onCancel,
    onSend,
    sendButtonText = "Send",
    cancelButtonText = "Cancel",
    closeOnOutsideClick = true,
}) => {
    return (
        <>
            <div className="overlay"></div>
            <OutsideClickHandler
                onOutsideClick={() => {
                    if (closeOnOutsideClick) {
                        onCancel()
                    }
                }}
            >
                <div className="model">
                    <div className="modal-content">
                        {/* Header */}
                        <div className="modal-header">
                            <h2 className="modal-title">{name}</h2>
                            <button
                                onClick={onCancel}
                                className="close-button"
                            >
                                ×
                            </button>
                        </div>

                        {/* Body */}
                        <div className="modal-body">
                            {bodyComponent}
                        </div>

                        {/* Buttons */}
                        <div className="modal-buttons">
                            <PLButton 
                                variant="secondary" 
                                size="lg"
                                onClick={onCancel}
                                className="button-flex"
                            >
                                {cancelButtonText}
                            </PLButton>
                            <PLButton 
                                variant="blue" 
                                size="lg"
                                onClick={onSend}
                                className="button-flex"
                            >
                                {sendButtonText}
                            </PLButton>
                        </div>
                    </div>
                </div>
            </OutsideClickHandler>
        </>
    );
};

export default ModelCmp;
